export default __webpack_public_path__ + "static/media/about-image.64bf71c3.jpg";